import { FunctionComponent } from 'react';

export const VersionNumber: FunctionComponent = () => {
  return <h6 className="text-tint text-sm font-medium opacity-50">{process.env.REACT_APP_VERSION}</h6>;
};
